export const isError = (value) => value instanceof Error;
